import {createReducer, on} from '@ngrx/store'
import {initialInfoState} from './types/InfoState';
import {aktualizujInfo} from './info.effect';

export const infoReducers = createReducer(
  initialInfoState,
  on(aktualizujInfo, (state, action) => {
    return {...state,
      build: action.build,
      application: action.application
    }
  })
)
